import { QueryCache, QueryClient } from "@tanstack/react-query";

import { GLOBAL_STALE_TIME } from "@/configs/api";
import { notify } from "@/hooks/useNotifications";

declare module "@tanstack/react-query" {
  interface Register {
    queryMeta: {
      errorMessage?: {
        text?: string;
        title?: string;
      };
    };
  }
}

export {};

export const MASTER_INVALIDATION_KEY = ["care-1.0"];

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: GLOBAL_STALE_TIME,
      experimental_prefetchInRender: true,
    },
  },
  queryCache: new QueryCache({
    onError: (_error, query) => {
      if (query.meta?.errorMessage) {
        notify.error(query.meta.errorMessage.text, query.meta.errorMessage.title);
      }
    },
  }),
});

export default queryClient;
